import React from 'react';
import { Modal } from '@carvana/showroom-modal';
import { Spinner } from '@carvana/showroom-spinner';

import {
  ModalContentWrapper,
  ContentHeader,
  ContentBody,
  CancelPaymentButton,
} from './CancelPaymentDialog.styles';
import CancelPaymentIcon from '../../../assets/CancelPaymentIcon';

const CancelPaymentDialog = ({
  toggleModal,
  isCancelPaymentLoading,
  openModal,
  withdrawAmount,
  cancelPaymentMethod,
}: any) => {
  const handleClick = () => {
    cancelPaymentMethod();
  };

  return (
    <>
      <Modal
        className="cancelPaymentDialog"
        headerText="Cancel Payment"
        closeModal={toggleModal}
        isOpen={openModal}
        testHook="test-modal"
        mode="light"
        portalDivId="cancel-payment"
      >
        <ModalContentWrapper>
          {isCancelPaymentLoading ? (
            <Spinner />
          ) : (
            <>
              <CancelPaymentIcon />
              <ContentHeader>
                Are you sure you want to cancel this payment to Bridgecrest for{' '}
                {withdrawAmount}?
              </ContentHeader>
              <ContentBody>
                By clicking &quot;Yes,&quot; I authorize Bridgecrest to cancel
                the payment for my account and I understand that it is my
                responsibility to make my payment through one of the other
                payment options.
              </ContentBody>
              <CancelPaymentButton
                id="cancelPaymentButton"
                onClick={handleClick}
              >
                Yes, Cancel Payment
              </CancelPaymentButton>
            </>
          )}
        </ModalContentWrapper>
      </Modal>
    </>
  );
};

export default CancelPaymentDialog;
